import { RiCheckboxCircleFill } from '@remixicon/react';
import { CommanderLogo } from '../assets/icons/AuthIcon';

/**
 * Public landing page for an external signer after they finish signing.
 * The e-sign provider redirects here via the document's `meta.redirectUrl`.
 *
 * Deliberately DATA-FREE (AC-8): shows no quote/customer/tenant information and
 * performs no lookup from URL params, so a guessed URL leaks nothing. The
 * signature status is finalized independently by the webhook, so this page is
 * purely presentational — the signer can close the tab safely.
 */
export default function EsignComplete() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4">
      <div className="mb-10">
        <CommanderLogo />
      </div>

      <div className="w-full max-w-md rounded-2xl border bg-card p-10 text-center shadow-sm">
        <RiCheckboxCircleFill className="mx-auto h-14 w-14 text-primary" />
        <h1 className="mt-6 text-2xl font-semibold text-foreground">Thank you — you're all set</h1>
        <p className="mt-3 text-muted-foreground">
          Your signature has been recorded. A copy of the signed document is on its way to your
          inbox.
        </p>
        <p className="mt-6 text-sm text-muted-foreground">You can safely close this window.</p>
      </div>

      <p className="mt-8 text-xs text-muted-foreground">Powered by Commander</p>
    </div>
  );
}
